module.exports = __webpack_public_path__ + "img/thedm.160e31a0.jpg";